import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { pageView, clickTrack, consentUpdate } from "../lib/analytics";

// One page_view per path (+ language), sent after the page has set its title.
export default function AnalyticsTracker() {
  const { pathname, search } = useLocation();
  const last = useRef("");
  const lang = new URLSearchParams(search).get("lang") || "";
  useEffect(() => {
    const k = `${pathname}|${lang}`;
    const t = setTimeout(() => { if (k !== last.current) { last.current = k; pageView(); } }, 400);
    return () => clearTimeout(t);
  }, [pathname, lang]);
  useEffect(() => {
    const on = (e) => consentUpdate(e.detail);
    document.addEventListener("click", clickTrack, true);
    window.addEventListener("amalfi-consent", on);
    return () => { document.removeEventListener("click", clickTrack, true); window.removeEventListener("amalfi-consent", on); };
  }, []);
  return null;
}
